import { CurrentOpenMenu } from '@/pages/Search/SearchPage/types';
import FacetTypes from '@/types/search/enums/facetTypes';
import { FilterAction } from '@/types/SearchFacet';
import { QuickFilterName } from '@/utils/amplitude/analytics/searchPage';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { FacetOptionsPill } from '../FacetOptionsPill/FacetOptionsPill';

type Props = {
    currentOpenMenu?: CurrentOpenMenu;
    onMenuClose: () => void;
    onMenuOpen: (currentMenu: CurrentOpenMenu) => void;
};

export const CreatorPill = ({ currentOpenMenu, onMenuClose, onMenuOpen }: Props) => {
    const formatMessage = useAppFormatMessage();
    return (
        <FacetOptionsPill
            currentOpenMenu={currentOpenMenu}
            facetId={FacetTypes.CREATOR_ID}
            filterActionChanged={FilterAction.CreatorChanged}
            filterActionRemoved={FilterAction.CreatorRemoved}
            /* As long as the translation key doesn't change, we can guarantee that this will be a string */
            label={String(formatMessage(['search_facet_title_creator']))}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            openMenuId={CurrentOpenMenu.Creator}
            quickFilterName={QuickFilterName.Creator}
        />
    );
};
